import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allmembersCount : 0,
    followingcount : 0,
    followerscount :0,
    mygroupcount : 0,
};

const profile = createSlice({
    name: 'product',
    initialState,
    reducers: {
        // Counts are badges, never negative: a missing or stale value reads 0,
        // and a stored negative can never leak through to the UI.
        setAllMemeberscount(state, action) {
            state.allmembersCount = Math.max(0, Number(action.payload) || 0);
        },
       setfollowingcount(state, action) {
            state.followingcount = Math.max(0, Number(action.payload) || 0);
        },
        setfollowerscount(state, action) {
            state.followerscount = Math.max(0, Number(action.payload) || 0);
        },
        setmygroupcount(state, action) {
            state.mygroupcount = Math.max(0, Number(action.payload) || 0);
        },
        setAddRemovefriend(state,action){
            const step = action.payload === 1 ? 1 : -1;
            state.followingcount = Math.max(0, state.followingcount + step);
        },

    }
});

// Export the actions
export const { setAllMemeberscount, setfollowingcount, setfollowerscount, setmygroupcount, setAddRemovefriend} = profile.actions;

export default profile.reducer;